import {isEditableMode, useFormMode} from "@contexts/FormModeContext";

export default function DynamicItemHeadingComponent(
   {
      text = 'Item',
      itemIndex = 1,
      onRemoveIconClick,
      skipHash = true
   }
) {
   
   const {mode} = useFormMode();
   
   return (
      <h3 className="my-2 col-12 d-flex justify-content-between align-items-center">
         <span>{text} {!skipHash && '#' }{itemIndex}</span>
         
         {isEditableMode(mode) && (
            <i className="fa fa-close text-danger" onClick={onRemoveIconClick} />
         )}
         
      </h3>
   );
   
}